
import { Dropdown } from "antd";
import { Observer } from 'mobx-react';
import moment from 'moment';
import React, { useState } from 'react';
import { ArrowDownIcon, DeleteIcon, InstitutionPlaceholderIcon, ThreeDotsIcon } from '../../../../assets/icons/common/common-icons';
import { CommonBadge } from '../../../../common/components/CommonBadge/CommonBadge';
import { useStore } from '../../../app/data/root.store';
import { ConnectedInstitutionDeleteModal } from './ConnectedInstitutionDeleteModal';
import { FlexSpace, InstitutionHeader, InstitutionHeaderWrapper, InstitutionIconWrapper, LastSyncPrompt, LogoPlaceHolder, PanelHeaderRightButtonsWrapper, PanelHeaderStatusWrapper, PanelHeaderWrapper, ThreeDotsIconWrapper, VipPendingText } from './ConnectedInstitutionsList.styles';
import { CommonActionMenuItem, CommonActionMenuWrapper, DeleteIconContainer } from '../../../../common/styles/menus.styles';
import { RefreshIcon, WebSiteIcon, instSyncTimeAgo } from './institutionPanel.commons';
import { cleanURL, addHttpPrefixIfMissing } from "../../../../common/utils/string.utils";
import { ActionLockedIconWithTooltip } from "../../../../common/components/ActionLocked/ActionLockedIconWithTooltip";
import {VipSyncStatusCard} from "../../../wealth/pages/asset/components/VipSyncing/VipSyncStatusCard";

export const VipConnectedInstitutionPanelHeaderRow = (props) => {
    const { institution, isOpen } = props;
    const [showConnectedInstitutionDeleteModal, setShowConnectedInstitutionDeleteModal] = useState(false);
    const { connectedInstitutionsStore, userStore, billingStore, metadataStore } = useStore();
    const connectedAccountsLength = institution.accounts?.filter(acc => acc.vipInstitutionConnection === 'connected').length || 0;
    const hasAnyConnectedAccount = connectedAccountsLength > 0;

    const handleUpdateMetadata = () => {
        metadataStore.fetchData();
    }

    const deleteInstitutionAccounts = (deleteType) => {
        return connectedInstitutionsStore.deleteAccounts('vip', institution.id, deleteType, () => {
            handleUpdateMetadata();
        });
    }

    const handlePanelOnClick = (e) => {
        if (userStore.isDemoOrReadOnlyMode) {
            billingStore.setShowPricingTableModal(true);
            e.stopPropagation();
        }
    }

    const handleDeleteInstitution = (action) => {
        if (action === 'manual') {
            deleteInstitutionAccounts('soft delete');
        }

        else if (action === 'archive') {
            deleteInstitutionAccounts('archive delete');
        }

        else if (action === 'delete' || !hasAnyConnectedAccount) {
            deleteInstitutionAccounts('hard delete');
        }

        handleUpdateMetadata();
        setShowConnectedInstitutionDeleteModal(false);
    }

    return (<Observer>{() => (
        <PanelHeaderWrapper onClick={handlePanelOnClick}>
            <InstitutionIconWrapper>
                {institution.logoBase64 ? <img style={{ width: '28px', height: '28px' }} alt={institution.institutionName} src={'data:image/png;base64,' + institution.logoBase64} /> :
                    institution.logoURL ? <img style={{ width: '28px', height: '28px' }} alt={institution.institutionName} src={institution.logoURL} /> :
                        <LogoPlaceHolder><InstitutionPlaceholderIcon /></LogoPlaceHolder>}
            </InstitutionIconWrapper>
            <InstitutionHeaderWrapper>
                <InstitutionHeader>{institution.institutionName} {institution.accounts?.length ? `(${institution.accounts.length})` : ''}</InstitutionHeader>
            </InstitutionHeaderWrapper>


            <FlexSpace />
            <PanelHeaderStatusWrapper>
                {institution.status === 'pending' && <VipPendingText><RefreshIcon />Pending</VipPendingText>}
                <CommonBadge badgeType={'vipService'} color={institution.status === 'pending' ? '#ACB1BB' : '#DEB482'} toolTipOverlayStyle={institution.status === 'pending' ? { maxWidth: '328px' } : {}} tooltipContent={institution.status === 'pending' ?
                    <div style={{ padding: '10px 16px' }}>
                        <div>Vip Syncing request in progress...</div>
                        <VipSyncStatusCard institutionName={institution.institutionName} status={'pending'} is3rdParty={institution.vipAccessRequirement !== 'manual'} maxWidth={'320px'} showAsCard={false} showAsToolTip={true} />
                    </div> : `Your ${institution.institutionName} data refreshes based on their reporting schedule\n(monthly or quarterly).`} />
                {institution.status !== 'pending' && institution.latestPulling && <LastSyncPrompt>Last sync: {instSyncTimeAgo(moment(institution.latestPulling).toDate())}</LastSyncPrompt>}
            </PanelHeaderStatusWrapper>
            <PanelHeaderRightButtonsWrapper>
                <ArrowDownIcon style={{ transition: '0.2s', transform: `rotate(${isOpen ? -180 : 0}deg)` }} />
                <Dropdown overlay={InstitutionActionMenu({
                    institutionId: institution.institutionId,
                    instUrl: institution.instUrl,
                    institutionName: institution.institutionName,
                    handleOnInstitutionDelete: () => setShowConnectedInstitutionDeleteModal(true),
                    onUpdateAccountsSuccess: (data) => { connectedInstitutionsStore.fetchVipAccounts(institution.id, true); },
                    userStore: userStore,
                })}
                    getPopupContainer={() => document.getElementById('syncedAccountsPage')}
                    trigger={['click']} placement='bottomRight'>
                    <ThreeDotsIconWrapper isOpen={isOpen} onClick={(e) => e.stopPropagation()}>
                        <ThreeDotsIcon />
                    </ThreeDotsIconWrapper>
                </Dropdown>
            </PanelHeaderRightButtonsWrapper>


            {showConnectedInstitutionDeleteModal && <div onClick={(e) => e.stopPropagation()}>
                <ConnectedInstitutionDeleteModal
                    onClose={() => setShowConnectedInstitutionDeleteModal(false)}
                    handleDelete={handleDeleteInstitution}
                    connectedAccountsLength={connectedAccountsLength}
                    title={institution.institutionName}
                    institution={institution}
                    provider={'vip'}
                    hideDeleteOption={true} />
            </div>}
        </PanelHeaderWrapper>
    )}</Observer>)
}

function InstitutionActionMenu({ instUrl, institutionName, handleOnInstitutionDelete, userStore }) {

    const handleDeleteInstitution = () => {
        if (!userStore.isActionBlockedByRole('deleteConnectedInstitution')) {
            handleOnInstitutionDelete();
        }
    }

    const handleSendSupportMessage = () => {
        const message = `${institutionName} is VIP synced, but I’m missing an asset. Can you help?`
        window.Intercom && window.Intercom('showNewMessage', message);
    }

    return (
        <CommonActionMenuWrapper onClick={(e) => e.stopPropagation()}>
            <CommonActionMenuItem onClick={handleSendSupportMessage}>
                <IntercomIcon />Missing asset? Check status
            </CommonActionMenuItem>
            {instUrl &&
                <CommonActionMenuItem>
                    <a href={addHttpPrefixIfMissing(instUrl)} target="_blank" rel="noreferrer">
                        <WebSiteIcon />{cleanURL(instUrl)}
                    </a>
                </CommonActionMenuItem>
            }
            <CommonActionMenuItem color={'red'} onClick={handleDeleteInstitution}>
                <DeleteIconContainer color={'red'}><DeleteIcon /></DeleteIconContainer>Delete {userStore.isActionBlockedByRole('deleteConnectedInstitution') && <ActionLockedIconWithTooltip isRoleBlocked={true} />}
            </CommonActionMenuItem>
        </CommonActionMenuWrapper>
    )
}

const IntercomIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path fillRule="evenodd" clipRule="evenodd" d="M15.2138 20.2126C17.8012 21.2475 21 22.5402 21 22.5402L20.9993 15.6054V5.04021C20.9993 3.63734 19.955 2.5 18.6671 2.5L4.33225 2.5C3.045 2.5 2 3.63804 2 5.03951L2 17.671C2 19.0738 3.045 20.2126 4.33225 20.2126H15.2138ZM5.85267 13.792C5.74687 13.7573 5.63499 13.744 5.52394 13.7528C5.41289 13.7616 5.30454 13.7924 5.20569 13.8436C5.10735 13.8945 5.02025 13.9647 4.95024 14.0504C4.80683 14.2224 4.73521 14.4419 4.75255 14.665C4.76842 14.8886 4.87317 15.0954 5.04158 15.2438L5.04354 15.2455C5.16111 15.347 7.40565 17.2502 11.5 17.2502C15.595 17.2502 17.8395 15.347 17.9571 15.2455L17.9593 15.2436C18.1274 15.0951 18.2318 14.8883 18.2474 14.6649C18.2648 14.4423 18.1935 14.2231 18.0505 14.0512C17.9803 13.9653 17.893 13.8949 17.7943 13.8439C17.6953 13.7927 17.5867 13.762 17.4754 13.7534C17.3641 13.7447 17.2521 13.7583 17.1462 13.7933C17.0414 13.828 16.9445 13.8831 16.8617 13.9558C16.7984 14.0088 14.9345 15.5499 11.5 15.5499C9.77095 15.5499 8.43243 15.1524 7.52464 14.7539C7.07055 14.5546 6.72414 14.3549 6.49068 14.2046C6.37397 14.1295 6.28556 14.0667 6.22613 14.0225C6.17243 13.9826 6.14277 13.9582 6.13751 13.9538C6.05452 13.8813 5.95749 13.8264 5.85267 13.792Z" fill="#1A1B1D" />
    </svg>
)